export default "__VITE_ASSET__CobyrG81__"